import { EquationBlock } from "./equationBlock";
import { FigureBlock } from "./figureBlock";
import { CodeBlockNode } from "./codeBlockNode";
import { TheoremBlock } from "./theoremBlock";
import { TableBlock } from "./tableBlock";
import { AbstractBlock } from "./abstractBlock";
import { TitleBlock } from "./titleBlock";
import { BibliographyBlock } from "./bibliographyBlock";
import { TocBlock } from "./tocBlock";
import { PageBreakBlock } from "./pageBreakBlock";
import { ColumnBreakBlock } from "./columnBreakBlock";
import { FootnoteBlockNode } from "./footnoteBlock";
import { EmbedBlock } from "./embedBlock";
import { ListBlock } from "./listBlock";
import { BlockquoteBlock } from "./blockquoteBlock";
import { AlgorithmBlock } from "./algorithmBlock";
import { CalloutBlock } from "./calloutBlock";
import { VerseBlock } from "./verseBlock";
import { AsideBlock } from "./asideBlock";
import { FrontMatterBlock } from "./frontMatterBlock";
import { BackMatterBlock } from "./backMatterBlock";
import { AnnotationBlock } from "./annotationBlock";
import { CoverBlock } from "./coverBlock";
import { ChapterBreakBlock } from "./chapterBreakBlock";
import { PersonalInfoBlock } from "./personalInfoBlock";
import { PhotoBlock } from "./photoBlock";
import { CvSectionBlock } from "./cvSectionBlock";
import { CvEntryBlock } from "./cvEntryBlock";
import type { Extensions } from "@tiptap/core";

export {
  EquationBlock,
  FigureBlock,
  CodeBlockNode,
  TheoremBlock,
  TableBlock,
  AbstractBlock,
  TitleBlock,
  BibliographyBlock,
  TocBlock,
  PageBreakBlock,
  ColumnBreakBlock,
  FootnoteBlockNode,
  EmbedBlock,
  ListBlock,
  BlockquoteBlock,
  AlgorithmBlock,
  CalloutBlock,
  VerseBlock,
  AsideBlock,
  FrontMatterBlock,
  BackMatterBlock,
  AnnotationBlock,
  CoverBlock,
  ChapterBreakBlock,
  PersonalInfoBlock,
  PhotoBlock,
  CvSectionBlock,
  CvEntryBlock,
};

/**
 * Returns all custom block node extensions for the single-editor architecture.
 */
export function getBlockNodeExtensions(): Extensions {
  return [
    EquationBlock,
    FigureBlock,
    CodeBlockNode,
    TheoremBlock,
    TableBlock,
    AbstractBlock,
    TitleBlock,
    BibliographyBlock,
    TocBlock,
    PageBreakBlock,
    ColumnBreakBlock,
    FootnoteBlockNode,
    EmbedBlock,
    ListBlock,
    BlockquoteBlock,
    AlgorithmBlock,
    CalloutBlock,
    VerseBlock,
    AsideBlock,
    FrontMatterBlock,
    BackMatterBlock,
    AnnotationBlock,
    CoverBlock,
    ChapterBreakBlock,
    PersonalInfoBlock,
    PhotoBlock,
    CvSectionBlock,
    CvEntryBlock,
  ];
}
